import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-25678e48"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "payment-buttons" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Betal med kort", -1))
const _hoisted_5 = { class: "other-payments-modal order-modal" }
const _hoisted_6 = { class: "head" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Annen betaling", -1))
const _hoisted_8 = {
  key: 0,
  class: "fields"
}
const _hoisted_9 = { class: "field" }
const _hoisted_10 = { class: "label" }
const _hoisted_11 = { class: "input-with-button" }
const _hoisted_12 = { class: "field" }
const _hoisted_13 = { class: "label" }
const _hoisted_14 = { class: "input-with-button" }
const _hoisted_15 = { class: "field" }
const _hoisted_16 = { class: "label" }
const _hoisted_17 = { class: "input-with-button" }
const _hoisted_18 = { class: "field" }
const _hoisted_19 = { class: "label" }
const _hoisted_20 = { class: "add-cash-buttons" }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { class: "cash-back" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "cash-back__label label" }, "Penger tilbake", -1))
const _hoisted_24 = { class: "cash-back__amount" }
const _hoisted_25 = { class: "action-buttons" }
const _hoisted_26 = { class: "order-modal confirm-mobile-modal" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Tast inn beløp på mobil terminal", -1))
const _hoisted_28 = { class: "confirm-amount" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text" }, "Når betaling er gjennomført, trykk ferdig.", -1))
const _hoisted_30 = { class: "confirm-mobile-buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SvgIcon = _resolveComponent("SvgIcon")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ValidationFormErrors = _resolveComponent("ValidationFormErrors")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_RegisterInvoicePaymentModal = _resolveComponent("RegisterInvoicePaymentModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.payed && !_ctx.isInvoiced)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_Button, {
            disabled: _ctx.buttonsDisabled,
            onClick: _ctx.payWithCard,
            class: "summary-button",
            color: "green"
          }, {
            default: _withCtx(() => [
              (_ctx.payingWithOnlyCard)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_SvgIcon, {
                      class: "animate-spin",
                      type: "mdi",
                      path: _ctx.loadingIcon
                    }, null, 8, ["path"]),
                    (_ctx.selectedCashRegister?.terminal_is_mobile)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_2, "Jobber"))
                      : (_openBlock(), _createElementBlock("span", _hoisted_3, "Venter på kortbetaling"))
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createVNode(_component_SvgIcon, {
                      type: "mdi",
                      path: _ctx.cardIcon
                    }, null, 8, ["path"]),
                    _hoisted_4
                  ], 64))
            ]),
            _: 1
          }, 8, ["disabled", "onClick"]),
          _createVNode(_component_Button, {
            disabled: _ctx.buttonsDisabled,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showPaymentModal = true)),
            class: "summary-button",
            color: "secondary"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_SvgIcon, {
                type: "mdi",
                path: _ctx.cashIcon
              }, null, 8, ["path"]),
              _createTextVNode("Annen betaling ")
            ]),
            _: 1
          }, 8, ["disabled"])
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.isInvoiced && !_ctx.payed)
      ? (_openBlock(), _createBlock(_component_Button, {
          key: 1,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showRegisterInvoicePaymentModal = true)),
          disabled: _ctx.buttonsDisabled,
          class: "summary-button",
          color: "green"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_SvgIcon, {
              type: "mdi",
              path: _ctx.invoicePaymentIcon
            }, null, 8, ["path"]),
            _createTextVNode("Registrer innbetaling ")
          ]),
          _: 1
        }, 8, ["disabled"]))
      : _createCommentVNode("", true),
    (_ctx.showPaymentModal)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 2,
          "with-card": true
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_ValidationFormErrors, {
                errors: _ctx.paymentForm.errors
              }, null, 8, ["errors"]),
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createVNode(_component_SvgIcon, {
                  class: "closeIcon",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showPaymentModal = false)),
                  type: "mdi",
                  path: _ctx.closeIcon
                }, null, 8, ["path"])
              ]),
              (_ctx.cashBack <= 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("label", _hoisted_10, [
                        _createTextVNode(" Kontant "),
                        _createElementVNode("div", _hoisted_11, [
                          _withDirectives(_createElementVNode("input", {
                            onFocus: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.selectText && _ctx.selectText(...args))),
                            type: "number",
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.paymentForm.cash) = $event))
                          }, null, 544), [
                            [_vModelText, _ctx.paymentForm.cash]
                          ]),
                          _createVNode(_component_Button, {
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.paymentForm.cash = _ctx.totalIncMva)),
                            color: "blue"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Hele beløpet")
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("label", _hoisted_13, [
                        _createTextVNode(" Kort "),
                        _createElementVNode("div", _hoisted_14, [
                          _withDirectives(_createElementVNode("input", {
                            onFocus: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.selectText && _ctx.selectText(...args))),
                            type: "number",
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.paymentForm.card) = $event))
                          }, null, 544), [
                            [_vModelText, _ctx.paymentForm.card]
                          ]),
                          _createVNode(_component_Button, {
                            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.paymentForm.card = _ctx.totalIncMva)),
                            color: "blue"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Hele beløpet")
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("label", _hoisted_16, [
                        _createTextVNode(" Faktura "),
                        _createElementVNode("div", _hoisted_17, [
                          _withDirectives(_createElementVNode("input", {
                            onFocus: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.selectText && _ctx.selectText(...args))),
                            type: "number",
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.paymentForm.invoice) = $event))
                          }, null, 544), [
                            [_vModelText, _ctx.paymentForm.invoice]
                          ]),
                          _createVNode(_component_Button, {
                            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.paymentForm.invoice = _ctx.totalIncMva)),
                            color: "blue"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Hele beløpet")
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("label", _hoisted_19, [
                        _createTextVNode(" Mottatt kontant "),
                        _withDirectives(_createElementVNode("input", {
                          onFocus: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.selectText && _ctx.selectText(...args))),
                          type: "number",
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.paymentForm.cash_received) = $event))
                        }, null, 544), [
                          [_vModelText, _ctx.paymentForm.cash_received]
                        ]),
                        _createElementVNode("div", _hoisted_20, [
                          _createVNode(_component_Button, {
                            class: "cash-button",
                            color: "white",
                            onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.addCash(50)))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("50,-")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Button, {
                            class: "cash-button",
                            color: "white",
                            onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.addCash(100)))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("100,-")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Button, {
                            class: "cash-button",
                            color: "white",
                            onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.addCash(200)))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("200,-")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Button, {
                            class: "cash-button",
                            color: "white",
                            onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.addCash(500)))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("500,-")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Button, {
                            class: "cash-button",
                            color: "white",
                            onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.addCash(1000)))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("1000,-")
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _hoisted_23,
                      _createVNode(_component_SvgIcon, {
                        class: "cash-back__icon",
                        type: "mdi",
                        path: _ctx.cashBackIcon
                      }, null, 8, ["path"]),
                      _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.toCurrency(_ctx.cashBack, true)) + ",-", 1)
                    ])
                  ])),
              _createElementVNode("div", _hoisted_25, [
                (_ctx.cashBack <= 0)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      class: "button pay-button",
                      disabled: _ctx.paymentForm.processing,
                      color: "green",
                      onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.sendPaymentForm()))
                    }, {
                      default: _withCtx(() => [
                        (_ctx.paymentForm.processing)
                          ? (_openBlock(), _createBlock(_component_SvgIcon, {
                              key: 0,
                              class: "animate-spin",
                              type: "mdi",
                              path: _ctx.loadingIcon
                            }, null, 8, ["path"]))
                          : _createCommentVNode("", true),
                        _createTextVNode("Betal ")
                      ]),
                      _: 1
                    }, 8, ["disabled"]))
                  : _createCommentVNode("", true),
                (_ctx.cashBack <= 0)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 1,
                      class: "button",
                      color: "gray",
                      onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.showPaymentModal = false))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Avbryt")
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.cashBack > 0)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 2,
                      onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.showPaymentModal = false)),
                      color: "green"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Ferdig")
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.showRegisterInvoicePaymentModal)
      ? (_openBlock(), _createBlock(_component_RegisterInvoicePaymentModal, {
          key: 3,
          onDismiss: _cache[22] || (_cache[22] = ($event: any) => (_ctx.showRegisterInvoicePaymentModal = false))
        }))
      : _createCommentVNode("", true),
    (_ctx.showConfirmMobileModal)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 4,
          onDismiss: _cache[26] || (_cache[26] = ($event: any) => (_ctx.showConfirmMobileModal = false)),
          "with-card": true
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("header", null, [
                _hoisted_27,
                _createVNode(_component_SvgIcon, {
                  class: "closeIcon",
                  onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.showConfirmMobileModal = false)),
                  type: "mdi",
                  path: _ctx.closeIcon
                }, null, 8, ["path"])
              ]),
              _createElementVNode("h4", _hoisted_28, _toDisplayString(_ctx.toCurrency(_ctx.paymentForm.card)), 1),
              _hoisted_29,
              _createElementVNode("div", _hoisted_30, [
                _createVNode(_component_Button, {
                  onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.sendPaymentForm(true))),
                  color: "green"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Ferdig")
                  ]),
                  _: 1
                }),
                _createVNode(_component_Button, {
                  onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.showConfirmMobileModal = false)),
                  color: "gray"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Avbryt")
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}